import React from "react";

const About = () => (
  <div data-testid="about-page">
    <section className="bg-navy text-white py-24 relative overflow-hidden">
      <img src="https://images.pexels.com/photos/28442317/pexels-photo-28442317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="overline text-gold">About</div>
        <h1 className="font-display text-4xl lg:text-6xl mt-4 max-w-3xl">Forte — Strength. Discretion. Results.</h1>
      </div>
    </section>

    <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline text-gold">Our Story</div>
      <h2 className="font-display text-3xl text-navy mt-3 mb-8">A modern brokerage for an older kind of service.</h2>
      <p className="text-slate-700 text-lg leading-relaxed">
        Forte Realty was founded on a simple thesis: principals deserve senior representation from start to finish.
        We built a boutique brokerage that pairs institutional discipline with white-glove service across residential, commercial, and healthcare transactions.
      </p>
      <p className="text-slate-700 text-lg leading-relaxed mt-6">
        Today, Forte is trusted by family offices, private physicians, multi-site DSOs, and repeat luxury clients in 37 markets across North America.
      </p>
    </section>

    <section className="bg-slate-50 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="overline text-gold">Team</div>
        <h2 className="font-display text-3xl text-navy mt-3 mb-12">Senior advisors, every seat.</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { n: "Sarah Wright", r: "Managing Broker", b: "20 years in luxury residential.", img: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&q=85" },
            { n: "Marcus Lane", r: "Healthcare Desk Lead", b: "Dental & medical transaction specialist.", img: "https://images.pexels.com/photos/28442317/pexels-photo-28442317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
            { n: "Elena Kim", r: "Commercial Advisor", b: "Class A office and retail.", img: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&q=85" },
          ].map((m) => (
            <div key={m.n} className="bg-white border border-slate-200" data-testid={`team-${m.n.toLowerCase().replace(/\s/g, "-")}`}>
              <div className="aspect-[4/5] overflow-hidden bg-slate-100">
                <img src={m.img} alt={m.n} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="overline text-gold">{m.r}</div>
                <div className="font-display text-2xl text-navy mt-2">{m.n}</div>
                <div className="text-sm text-slate-600 mt-3">{m.b}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20 text-center">
      <div className="overline text-gold">Mission</div>
      <p className="font-display italic text-3xl lg:text-4xl text-navy mt-6 leading-snug">
        "To be the most trusted senior advisor for consequential real estate decisions — across home, enterprise, and healthcare."
      </p>
    </section>
  </div>
);

export default About;
